// @flow
import { validateRequired } from './validations'
import { t } from '../../core/i18n'

// Location validation errors
export const SELECT_ADDRESS_ERROR = 'Select address error'
export const US_ONLY_ERROR = 'US only error'

type LocationValues = {
  location: string,
  lat: string,
  lng: string,
  country: string,
  countryCode: string
}

export const validateIsLocationCompleted = (values: LocationValues) => {
  const { location, lat, lng } = values
  return (!location || !lat || !lng) && SELECT_ADDRESS_ERROR
}

export const validateIsLocationWithCountryCompleted = (
  values: LocationValues
) => {
  const { location, lat, lng, country, countryCode } = values
  return (
    (!location || !lat || !lng || !country || !countryCode) &&
    SELECT_ADDRESS_ERROR
  )
}

export const validateLocationUsOnly = (values: LocationValues) => {
  const { countryCode } = values
  return countryCode !== 'US' && US_ONLY_ERROR
}

export const validateCharityLocation = (values: LocationValues) => {
  const { location, lat, lng, country, countryCode } = values
  const selectAddressError = validateIsLocationWithCountryCompleted(values)
  const usOnlyError = validateLocationUsOnly(values)
  const error = () => {
    if (selectAddressError) return selectAddressError
    if (usOnlyError) return usOnlyError
    return false
  }
  return {
    location: validateRequired(location),
    lng: validateRequired(lng),
    lat: validateRequired(lat),
    country: validateRequired(country),
    countryCode: validateRequired(countryCode),
    _error: error()
  }
}

export const validateAuctionLocation = (values: LocationValues) => {
  const selectAddressError = validateIsLocationCompleted(values)
  return selectAddressError
    ? t('app:forms.validation.errorSelectAddress')
    : false
}

export const validateItemLocation = (values: LocationValues) => {
  const { location } = values
  const selectAddressError = location && validateIsLocationCompleted(values)
  return selectAddressError
    ? t('app:forms.validation.errorSelectAddress')
    : false
}



// WEBPACK FOOTER //
// ./src/services/validations/locations.js